// Quote Cart
const QUOTE_STORAGE_KEY = 'shopify_quote_cart';

const QuoteCart = {
  getItems() {
    try {
      return JSON.parse(localStorage.getItem(QUOTE_STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  },

  saveItems(items) {
    localStorage.setItem(QUOTE_STORAGE_KEY, JSON.stringify(items));
    this.updateCountBadges();
  },

  addItem(productId, variantId, title, quantity, image, url) {
    const items = this.getItems();
    const existing = items.find(i => i.variantId === variantId);
    if (existing) {
      existing.quantity = parseInt(existing.quantity) + parseInt(quantity);
    } else {
      items.push({
        productId: productId,
        variantId: variantId,
        title: title,
        quantity: parseInt(quantity),
        image: image,
        url: url
      });
    }
    this.saveItems(items);
  },

  removeItem(variantId) {
    const items = this.getItems().filter(function(i) {
      return i.variantId !== variantId;
    });
    this.saveItems(items);
  },

  clearItems() {
    localStorage.removeItem(QUOTE_STORAGE_KEY);
    this.updateCountBadges();
  },

  getCount() {
    return this.getItems().reduce(function(sum, i) {
      return sum + i.quantity;
    }, 0);
  },

  updateCountBadges() {
    var count = this.getCount();
    var badges = document.querySelectorAll('[data-quote-count]');
    badges.forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }
};

// Use event delegation on document so it works regardless of when DOM loads
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.quote-add-btn');
  if (!btn) return;

  // Prevent any form submission
  e.preventDefault();
  e.stopPropagation();

  var productId = btn.getAttribute('data-product-id');
  var variantId = btn.getAttribute('data-variant-id');
  var title = btn.getAttribute('data-title');
  var image = btn.getAttribute('data-image');
  var url = btn.getAttribute('data-url');

  // Try to get quantity from page
  var qtyInput = document.querySelector('.quantity__input, input[name="quantity"]');
  var quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

  // Add to quote
  QuoteCart.addItem(productId, variantId, title, quantity, image, url);

  // Show feedback on button
  var textEl = btn.querySelector('.quote-btn__text');
  if (textEl) {
    var original = textEl.textContent;
    textEl.textContent = '✓ Added to Quote';
    btn.style.backgroundColor = '#38a169';
    btn.style.borderColor = '#38a169';
    setTimeout(function() {
      textEl.textContent = original;
      btn.style.backgroundColor = '';
      btn.style.borderColor = '';
    }, 2000);
  }
}, true); // true = capture phase, fires before any other handler

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  QuoteCart.updateCountBadges();

  // Quote page rendering
  if (document.getElementById('quote-items-list')) {
    renderQuotePage();
  }

  // Update hidden field before form submit
  var form = document.getElementById('quote-contact-form');
  if (form) {
    form.addEventListener('submit', function() {
      var items = QuoteCart.getItems();
      var hiddenItems = document.getElementById('quote-hidden-items');
      if (hiddenItems) {
        hiddenItems.value = items.map(function(i) {
          return '• ' + i.title + ' — Qty: ' + i.quantity;
        }).join('\n');
      }
      setTimeout(function() { QuoteCart.clearItems(); }, 1000);
    });
  }
});

function renderQuotePage() {
  var items = QuoteCart.getItems();
  var quoteList = document.getElementById('quote-items-list');
  var emptyState = document.getElementById('quote-empty-state');
  var quoteForm = document.getElementById('quote-form-section');

  if (!quoteList) return;

  if (items.length === 0) {
    quoteList.innerHTML = '';
    if (emptyState) emptyState.style.display = 'block';
    if (quoteForm) quoteForm.style.display = 'none';
    return;
  }

  if (emptyState) emptyState.style.display = 'none';
  if (quoteForm) quoteForm.style.display = 'block';

  quoteList.innerHTML = items.map(function(item) {
    return '<div class="quote-item" data-variant-id="' + item.variantId + '">' +
      '<div class="quote-item__image">' +
        (item.image
          ? '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">'
          : '<div class="quote-item__image-placeholder"></div>') +
      '</div>' +
      '<div class="quote-item__info">' +
        '<a href="' + item.url + '" class="quote-item__title">' + item.title + '</a>' +
      '</div>' +
      '<div class="quote-item__qty">' +
        '<button type="button" class="quote-qty-btn" onclick="changeQty(\'' + item.variantId + '\', -1)">−</button>' +
        '<input type="number" class="quote-qty-input" value="' + item.quantity + '" min="1" onchange="updateQty(\'' + item.variantId + '\', this.value)">' +
        '<button type="button" class="quote-qty-btn" onclick="changeQty(\'' + item.variantId + '\', 1)">+</button>' +
      '</div>' +
      '<button type="button" class="quote-item__remove" onclick="removeQuoteItem(\'' + item.variantId + '\')" aria-label="Remove">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
          '<line x1="18" y1="6" x2="6" y2="18"></line>' +
          '<line x1="6" y1="6" x2="18" y2="18"></line>' +
        '</svg>' +
      '</button>' +
    '</div>';
  }).join('');

  // Update hidden input
  var hiddenItems = document.getElementById('quote-hidden-items');
  if (hiddenItems) {
    hiddenItems.value = items.map(function(i) {
      return '• ' + i.title + ' — Qty: ' + i.quantity;
    }).join('\n');
  }
}

function changeQty(variantId, delta) {
  var items = QuoteCart.getItems();
  var item = items.find(function(i) { return i.variantId === variantId; });
  if (!item) return;
  item.quantity = Math.max(1, item.quantity + delta);
  QuoteCart.saveItems(items);
  renderQuotePage();
}

function updateQty(variantId, value) {
  var items = QuoteCart.getItems();
  var item = items.find(function(i) { return i.variantId === variantId; });
  if (!item) return;
  item.quantity = Math.max(1, parseInt(value) || 1);
  QuoteCart.saveItems(items);
  renderQuotePage();
}

function removeQuoteItem(variantId) {
  QuoteCart.removeItem(variantId);
  renderQuotePage();
}